<template>
    <div class="talk-right-pane">
        <button
            v-if="!summaryExpanded && localIsTalkgroup && summaryHistoryAppEnabled && selectedTabName === 'talkRecord'"
            class="talk-right-pane-summary-entry"
            type="button"
            @click="$emit('toggle-summary')">
            <span v-t="'message.title_summaryHistory'"></span><i class="el-icon-arrow-left"></i>
        </button>
        <el-tabs v-if="showTab" v-model="selectedTabName" class="talk-right-pane-tabs" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.title_talkList')" name="talkRecord">
                <talkrecord-list
                    v-if="selectedTabName === 'talkRecord'"
                    v-bind:appData="localAppData"
                    v-bind:fromDateTime="localFromDateTime"
                    v-bind:toDateTime="localToDateTime"
                    v-bind:languageIndex="localLanguageIndex"
                    v-bind:selected="localSelected"
                    v-bind:isTalkgroup="localIsTalkgroup"
                    v-bind:summaryGenerating="summaryGenerating"
                    @language-change="$emit('language-change', $event)"
                    @summary-target-change="$emit('summary-target-change', $event)"
                    @open-summary-generate="$emit('open-summary-generate')">
                </talkrecord-list>
            </el-tab-pane>
            <el-tab-pane v-if="hasBuddycomCall" :label="$t('message.title_talkList_call')" name="BuddycomCallRecord">
                <buddycom-call-talk-record-list
                    v-if="selectedTabName === 'BuddycomCallRecord'"
                    v-bind:appData="localAppData"
                    v-bind:fromDateTime="localFromDateTime"
                    v-bind:toDateTime="localToDateTime"
                    v-bind:languageIndex="localLanguageIndex"
                    v-bind:selected="localSelected"
                    v-bind:isTalkgroup="localIsTalkgroup">
                </buddycom-call-talk-record-list>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import commonUtil from '../commonutil.js';
import TalkrecordList from "./TalkrecordList.vue";
import BuddycomCallTalkRecordList from "../buddycomcall/BuddycomCallTalkRecordList.vue";
import InitialTalkRightPane from "./InitialTalkRightPane.vue";

export default {
    components: {
        TalkrecordList,
        BuddycomCallTalkRecordList,
        InitialTalkRightPane
    },
    props: {
        selectedNode: { type: Object, default: null },
        appData: { type: Object, required: true },
        fromDateTime: { type: Date, default: () => new Date() },
        toDateTime: { type: Date, default: () => new Date() },
        languageIndex: { type: Number, default: 0 },
        selected: { type: Array, default: () => [] },
        selectedItemType: { type: String, default: '' },
        isTalkgroup: { type: Boolean, default: true },
        summaryExpanded: { type: Boolean, default: false },
        // 要約の生成が進行中かどうか。true になった時点で TalkrecordList 側の要約対象選択モードを終了する
        summaryGenerating: { type: Boolean, default: false }
    },
    data() {
        return {
            // Default to talkRecord tab; list components show their own initial notice when nothing is selected
            selectedTabName: 'talkRecord',
            // Local cached copies of props to survive tab switches or transient parent updates
            localSelectedNode: null,
            localAppData: {},
            localFromDateTime: new Date(),
            localToDateTime: new Date(),
            localLanguageIndex: 0,
            localSelected: [],
            localSelectedItemType: '',
            localIsTalkgroup: false,
            // Local copies for BuddyComCall feature flags to ensure reactive updates on nested changes
            localEnableBuddyComCall: false,
            localEnableBuddyComCallTrial: false
        };
    },
    computed: {
        showTab() {
            // Always show tabs; initial content guides the user before selection
            return true;
        },
        hasBuddycomCall() {
            // Call tab appears only when enabled and target is talkgroup
            return (this.localEnableBuddyComCall || this.localEnableBuddyComCallTrial) && !!this.localIsTalkgroup;
        },
        summaryHistoryAppEnabled() {
            return commonUtil.isSummaryHistoryEnabled(this.localAppData.apps);
        }
    },
    created() {
        // Initialize local cache from initial props
        this.syncFromProps({
            selectedNode: this.selectedNode,
            appData: this.appData,
            fromDateTime: this.fromDateTime,
            toDateTime: this.toDateTime,
            languageIndex: this.languageIndex,
            selected: this.selected,
            selectedItemType: this.selectedItemType,
            isTalkgroup: this.isTalkgroup
        });
        // Initialize local feature flags from appData
        if (this.appData) {
            this.localEnableBuddyComCall = !!this.appData.enableBuddyComCall;
            this.localEnableBuddyComCallTrial = !!this.appData.enableBuddyComCallTrial;
        }
    },
    watch: {
        selectedNode(newVal) { if (newVal !== undefined && newVal !== null) this.localSelectedNode = newVal; },
        appData(newVal) {
            if (newVal !== undefined && newVal !== null) {
                this.localAppData = newVal;
                // sync feature flags when appData reference changes
                this.localEnableBuddyComCall = !!newVal.enableBuddyComCall;
                this.localEnableBuddyComCallTrial = !!newVal.enableBuddyComCallTrial;
            }
        },
        fromDateTime(newVal) { if (newVal) this.localFromDateTime = new Date(newVal); },
        toDateTime(newVal) { if (newVal) this.localToDateTime = new Date(newVal); },
        languageIndex(newVal) { if (newVal !== undefined && newVal !== null) this.localLanguageIndex = newVal; },
        selected(newVal) {if (Array.isArray(newVal)) this.localSelected = newVal.slice();},
        selectedItemType(newVal) {
            if (newVal !== undefined && newVal !== null && newVal !== '') this.localSelectedItemType = newVal;
            if (newVal === commonUtil.getMessageText(this.$i18n,"item_user")) {
                this.selectedTabName = 'talkRecord';
            }
        },
        isTalkgroup(newVal) {if (typeof newVal === 'boolean') this.localIsTalkgroup = newVal;},
        'appData.enableBuddyComCall'(val) { this.localEnableBuddyComCall = !!val; },
        'appData.enableBuddyComCallTrial'(val) { this.localEnableBuddyComCallTrial = !!val; },
        // ユーザー操作(タブクリック)だけでなく selectedItemType の変化による自動タブ切替も
        // 拾う必要があるため、handleChangeTab 個別ではなくここで一元的に親へ通知する
        selectedTabName: {
            immediate: true,
            handler(newVal) { this.$emit('active-tab-change', newVal); }
        }
    },
    methods: {
        getMessageText(messageKey) {
            return commonUtil.getMessageText(this.$i18n, messageKey);
        },
        handleChangeTab(tab) {
            // Element UI passes TabPane instance; sync selectedTabName with its name
            if (tab && tab.name) {
                this.selectedTabName = tab.name;
                // 要約履歴は通話履歴(発話)タブでのみ扱う。他タブへ切り替えたら開いていても畳む
                if (tab.name !== 'talkRecord') {
                    this.$emit('collapse-summary');
                }
            }
        },
        beforeLeave() {
            return true;
        },
        syncFromProps(p) {
            if (!p) p = {};
            if (p.selectedNode !== undefined && p.selectedNode !== null) this.localSelectedNode = p.selectedNode;
            if (p.appData !== undefined && p.appData !== null) this.localAppData = p.appData;
            if (p.fromDateTime) this.localFromDateTime = new Date(p.fromDateTime);
            if (p.toDateTime) this.localToDateTime = new Date(p.toDateTime);
            if (p.languageIndex !== undefined && p.languageIndex !== null) this.localLanguageIndex = p.languageIndex;
            if (Array.isArray(p.selected)) this.localSelected = p.selected.slice();
            if (p.selectedItemType !== undefined && p.selectedItemType !== null && p.selectedItemType !== '') this.localSelectedItemType = p.selectedItemType;
            if (typeof p.isTalkgroup === 'boolean') this.localIsTalkgroup = p.isTalkgroup;
        }
    }
}
</script>

<style scoped>
.talk-right-pane {
    height: 100%;
    min-height: 0;
    min-width: 0;
    position: relative;
}

.talk-right-pane-summary-entry {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    margin: 0;
    border: none;
    background: transparent;
    color: #5171cb;
    font-size: 13px;
    cursor: pointer;
    z-index: 10;
}
.talk-right-pane-summary-entry i {
    margin-left: 4px;
    vertical-align: middle;
}
.talk-right-pane-summary-entry:hover {
    opacity: 0.7;
}

.talk-right-pane-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
    display: flex;
    flex: 1;
    min-height: 0;
    min-width: 0;
}
.el-tabs--border-card >>> .el-tab-pane {
    flex: 1;
    min-height: 0;
    min-width: 0;
}
.el-tabs--border-card {
    border: none;
}

.talkgroup-user-header1 >>> .el-select .el-input {
    font-size: 12px;
    width: 200px;
}
.talkgroup-user-header1 >>> .el-input__inner {
    height: 30px;
}
.talkgroup-user-header1 >>> .el-input__icon {
    line-height: 30px;
}

</style>
